import { useGetDetailedBalanceQuery } from '@/api/v1';
import { ENVIRONMENT } from '@/constants';
import { useCustomer } from '@/hooks/useCustomer';
import { DetailedBalance } from '@/types/bankInfo';
import { CurrencyCodeType } from '@/types/currency';

// @deprecated should use `useBalances`
export const useBalance = (currencyCode: CurrencyCodeType): DetailedBalance => {
  const customer = useCustomer();
  const { data: available = DetailedBalance.zero(currencyCode) } = useGetDetailedBalanceQuery(
    {
      beneficiaryId: customer.beneficiaryId,
      currency: currencyCode,
    },
    {
      skip: !customer.beneficiaryId,
      pollingInterval:
        ENVIRONMENT === 'develop' || ENVIRONMENT === 'preview-develop' || ENVIRONMENT === 'local'
          ? undefined
          : 2500,
      skipPollingIfUnfocused: true,
    },
  );

  return {
    total: available.total,
    available: available.available,
    pending: available.pending,
    currencyCode: currencyCode,
  };
};
